export const onDone = creds => ({
  widget: 'recoverPass',
  type: 'onDone',
  payload: { creds },
})



// WEBPACK FOOTER //
// ./src/recover-pass/actions/onDone.js